import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { AnimatedLogo } from "../Logo/AnimatedLogo";

const colors = ["#007167", "#008d83", "#3aafa9", "#def1f1"];

const pulseKeyframes = keyframes`
  0% {
    transform: scale(0.6);
    opacity: 0.6;
    filter: blur(1px);
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
    filter: blur(4px);
  }
  100% {
    transform: scale(2);
    opacity: 0;
    filter: blur(6px);
  }
`;

interface RadialLoadingProps {
  size?: string;
  logoSize?: string;
}

export default function RadialLoading({
  size = "50px",
  logoSize = "1.4rem",
}: RadialLoadingProps) {
  const pulseStyles = {
    position: "absolute" as const,
    borderRadius: "50%",
    width: size,
    height: size,
    border: "8px solid",
    animation: `${pulseKeyframes} 3s ease-out infinite`,
  };

  return (
    <Box
      position="relative"
      w="full"
      h="7rem"
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      <Box position="relative" boxSize={size}>
        {colors.map((color, index) => (
          <Box
            key={index}
            {...pulseStyles}
            borderColor={color}
            animationDelay={`${index * 0.4}s`}
            bg={color}
          />
        ))}

        <Box
          position="absolute"
          top="44%"
          left="50%"
          transform="translate(-50%, -50%)"
        >
          <AnimatedLogo size={logoSize} color="primary.700" />
        </Box>
      </Box>
    </Box>
  );
}
